import { useUsers } from '../../metodos/userContext';
import React, { useState, useEffect } from 'react';
import { solicitudesApi } from '../../services/api';
import { Cotizacion } from '../../objetos/Solicitud/objeto_solicitud';


export const useHistorialCotizacionesModel = () => {
    const { usuario } = useUsers();
    const [cotizaciones, setCotizaciones] = useState([]);
    const [cargandoCotizaciones, setCargando] = useState(false);
    const [errorCotizaciones, setError] = useState(null);
    const [nextPageToken, setNextPageToken] = useState(null);
    const [hasMore, setHasMore] = useState(true);


    //cargar cotizaciones
    const cargarCotizaciones = async (cararMas = false) => {
        try{
            setCargando(true);
            setError(null);

            // Solo usar el token de paginación si estamos cargando más
            const token = cargarMas ? nextPageToken : null;

            const resultado = await solicitudesApi.getTutorCotizaciones(
                usuario.nombrewhatsapp, 
                token,
                10,
            );

            console.log("resultado de cotizaciones",resultado);

            //convertir datos
            const dataConvertida = Object.values(resultado.cotizaciones);
            const cotizacionObj = dataConvertida.map(item => Cotizacion.fromJson(item));

            console.log("cotizaciones",cotizacionObj);

             //fromJson()


            if (cargarMas) {
                // Añadir a las existentes
                setCotizaciones(prev => [...prev, ...cotizacionObj]);
            } else {
                // Reemplazar las existentes
                setCotizaciones(cotizacionObj);
            }

            setNextPageToken(resultado.nextPageToken);
            setHasMore(resultado.hasMore);

        }
        catch(error){
            setError('Error al cargar cotizaciones: ' + error.message);
        } finally{
            setCargando(false);
        }
    }

    // Función para cargar más cotizaciones
    const cargarMas = () => {
        if (!cargandoCotizaciones && hasMore) {
        cargarCotizaciones(true);
        }
    };

    return{
        cotizaciones,
        cargandoCotizaciones,
        errorCotizaciones,
        cargarCotizaciones,
        cargarMas,
        hasMore,
    }


}
